var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThemes({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.03658 2.25H17.9635C18.6762 2.25 19.25 2.82375 19.25 3.53645L19.018 10.9951H5.89138L5.75018 3.53645C5.73813 2.82385 6.32388 2.25 7.03658 2.25Z",
    stroke: "black",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.018 10.9961V13.3118C19.1042 14.2542 17.9516 14.2429 17.2041 14.2468C14.4572 14.261 13.8871 15.5303 13.9695 16.8924C14.0472 18.1782 14.0678 18.3413 14.0854 19.0669C14.1279 20.8106 13.2879 21.7509 12.4546 21.7509C11.6214 21.7509 10.7814 20.8106 10.8239 19.0669C10.8416 18.3412 10.8621 18.1782 10.9398 16.8924C11.0222 15.5303 10.4521 14.2609 7.70523 14.2468C6.95773 14.2429 5.80513 14.2542 5.89128 13.3118V10.9961",
    stroke: "black",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemes);
export default __webpack_public_path__ + "static/media/Themes.d0e10da9d4485d8872acd8ba266ad3c0.svg";
export { ForwardRef as ReactComponent };